import Watch1 from '../assets/watch1.png';
import Watch2 from '../assets/watch2.png';
import Watch3 from '../assets/watch3.png';
import Watch4 from '../assets/watch4.png';
import Watch5 from '../assets/watch5.png';
import Watch6 from '../assets/watch6.png';
import Watch7 from '../assets/watch7.png';
import Watch8 from '../assets/watch8.png';
import Watch9 from '../assets/watch9.png';
import Watch10 from '../assets/watch10.png';
import Watch11 from '../assets/watch11.png';
import Watch12 from '../assets/watch12.png';
import Watch13 from '../assets/watch13.png';
import Watch14 from '../assets/watch14.png';
import Watch15 from '../assets/watch15.png';
import Watch16 from '../assets/watch16.png';
import Watch17 from '../assets/watch17.png';
import Watch18 from '../assets/watch18.png';
import {
  Branding,
  OneClickTermsConditionsE,
  TermsConditionsE,
  TermsConditionsW,
  VoWifiA,
  WatchA,
  WatchManager,
  WatchTransfer,
} from '../components/WebSheetTemplates/templates';

export const AVAILABLE = 'AVAILABLE' as const;
export const NOT_VISIBLE = 'NOT_VISIBLE' as const;
export const OEM_STATUS = 'eligibility_status' as const;
export const ANDROID_STATUS = 'eligibility_status_android' as const;

export const DEVICE_TYPES = {
  IOS: 'ios',
  ANDROID: 'android',
} as const;

export const ELIGIBILITY_DEVICE_STATUS_MAP = {
  [OEM_STATUS]: DEVICE_TYPES.IOS,
  [ANDROID_STATUS]: DEVICE_TYPES.ANDROID,
} as const;

export const USE_CASE_NAMES = {
  HEALTH_CHECK: 'HEALTH_CHECK',
  DEVICE_TRANSFER: 'Device_Transfer',
  VO_WIFI: 'VoWiFi',
  WATCH: 'Watch_Activation',
  RCS: 'RCS_Activation',
  ESIM_QUICK_TRANSFER: 'eSIM Transfer',
  VOLTE: 'VoLTE',
  VOLTE_DEFAULT_ON: 'VoLTE_Default_On',
  IPAD: 'iPad_Activation',
} as const;

export const VOWIFI_VERSIONS = {
  'vowifi-splash': 'vowifi-splash',
  'vowifi-t&c': 'vowifi-t&c',
  'vowifi-address': 'vowifi-address',
  'vowifi-confirmation': 'vowifi-confirmation',
} as const;

export const ESIM_TRANSFER_VERSIONS = {
  't&c': 't&c',
  one_click_tc: 'one_click_tc',
} as const;

export const WEBSHEET_TEMPLATE_TYPES = {
  BRANDING: 'branding',
  ESIM_TRANSFER: 'esim_transfer',
  WATCH: 'watch',
  VOWIFI: 'vowifi',
  TRANSFER_T_C: 'transfer_t&c',
} as const;

export const WEBSHEET_TAGS = {
  WS_ESIM_QUICK_TRANSFER: 'WS_ESIM_QUICK_TRANSFER',
  WS_WATCH_ACTIVATE: 'WS_WATCH_ACTIVATE',
  WS_VOWIFI_ACTIVATE: 'WS_VOWIFI_ACTIVATE', // TODO: THIS WILL BE DELETED SOON WHEN BRIDGE KEEPER IS GONE
} as const;

export const WS = {
  UC_TAGS: [
    'DEVICE_TRANSFER_FULL_WEB_SHEET',
    'DEVICE_TRANSFER_WEB_SHEET',
    'DT_FULL_WEB_SHEET_PSIM_TO_ESIM_ANDROID',
    'DT_FULL_WEB_SHEET_ESIM_TO_ESIM',
    'DT_FULL_WEB_SHEET_PSIM_TO_ESIM',
    'DEVICE_TRANSFER_FULL_WEB_SHEET',
    'DT_FULL_WEB_SHEET_CONVERSION',
  ],
  DEVICE_TRANSFER_WEB_SHEET: 'DEVICE_TRANSFER_WEB_SHEET',
  RESUME_TEST_EXECUTION: 'RESUME_TEST_EXECUTION',
  RESUME_ACKNOWLEDGE: 'RESUME_ACKNOWLEDGE',
  CANCEL_TEST_EXECUTION: 'CANCEL_TEST_EXECUTION',
  WEBSHEETS_POPUP_MESSAGES: 'WEBSHEETS_POPUP_MESSAGES',
  WEBSHEETS_CHANNEL_MESSAGES: 'WEBSHEETS_CHANNEL_MESSAGES',
  PROPAGATE_TEST_EXECUTION_COMPLETE: 'PROPAGATE_TEST_EXECUTION_COMPLETE',
  GET_TEST_EXECUTION: 'GET_TEST_EXECUTION',
  STORE_POPUP_REFERENCE: 'STORE_POPUP_REFERENCE',
  CANCELLED: 'CANCELLED',
  RESUME: 'RESUME',
  PAUSED: 'Paused',
  PENDING: 'Pending',
} as const;

export const templates = {
  [WEBSHEET_TEMPLATE_TYPES.BRANDING]: {
    branding: Branding,
  },
  [WEBSHEET_TEMPLATE_TYPES.ESIM_TRANSFER]: {
    a: TermsConditionsE,
    [ESIM_TRANSFER_VERSIONS['t&c']]: TermsConditionsE,
    [ESIM_TRANSFER_VERSIONS.one_click_tc]: OneClickTermsConditionsE,
  },
  [WEBSHEET_TEMPLATE_TYPES.WATCH]: {
    a: WatchA,
    watch: WatchA,
    manage: WatchManager,
    't&c': TermsConditionsW,
    'transfer_t&c': WatchTransfer,
    transfer: WatchTransfer,
  },
  [WEBSHEET_TEMPLATE_TYPES.TRANSFER_T_C]: { a: TermsConditionsE },
  // TODO - In the future we will integrate VoWifi UseCase
  [WEBSHEET_TEMPLATE_TYPES.VOWIFI]: {
    a: VoWifiA,
    [VOWIFI_VERSIONS['vowifi-splash']]: VoWifiA,
    [VOWIFI_VERSIONS['vowifi-t&c']]: VoWifiA,
    [VOWIFI_VERSIONS['vowifi-address']]: VoWifiA,
    [VOWIFI_VERSIONS['vowifi-confirmation']]: VoWifiA,
  },
} as const;

export const WATCH_ASSETS = {
  none: undefined,
  watch1: Watch1,
  watch2: Watch2,
  watch3: Watch3,
  watch4: Watch4,
  watch5: Watch5,
  watch6: Watch6,
  watch7: Watch7,
  watch8: Watch8,
  watch9: Watch9,
  watch10: Watch10,
  watch11: Watch11,
  watch12: Watch12,
  watch13: Watch13,
  watch14: Watch14,
  watch15: Watch15,
  watch16: Watch16,
  watch17: Watch17,
  watch18: Watch18,
} as const;

export const WATCH_IMAGES = {
  watch1: {
    name: 'watch1',
    altText: 'watch 1',
    android: true,
    src: WATCH_ASSETS.watch1,
  },
  watch2: {
    name: 'watch2',
    altText: 'watch 2',
    ios: true,
    src: WATCH_ASSETS.watch2,
  },
  watch3: {
    name: 'watch3',
    altText: 'watch 3',
    android: true,
    src: WATCH_ASSETS.watch3,
  },
  watch4: {
    name: 'watch4',
    altText: 'watch 4',
    src: WATCH_ASSETS.watch4,
  },
  watch5: {
    name: 'watch5',
    altText: 'watch 5',
    src: WATCH_ASSETS.watch5,
  },
  watch6: {
    name: 'watch6',
    altText: 'watch 6',
    src: WATCH_ASSETS.watch6,
  },
  watch7: {
    name: 'watch7',
    altText: 'watch 7',
    src: WATCH_ASSETS.watch7,
  },
  watch8: {
    name: 'watch8',
    altText: 'watch 8',
    src: WATCH_ASSETS.watch8,
  },
  watch9: {
    name: 'watch9',
    altText: 'watch 9',
    src: WATCH_ASSETS.watch9,
  },
  watch10: {
    name: 'watch10',
    altText: 'watch 10',
    ios: true,
    src: WATCH_ASSETS.watch10,
  },
  watch11: {
    name: 'watch11',
    altText: 'watch 11',
    ios: true,
    src: WATCH_ASSETS.watch11,
  },
  watch12: {
    name: 'watch12',
    altText: 'watch 12',
    android: true,
    src: WATCH_ASSETS.watch12,
  },
  watch13: {
    name: 'watch13',
    altText: 'watch 13',
    android: true,
    src: WATCH_ASSETS.watch13,
  },
  watch14: {
    name: 'watch14',
    altText: 'watch 14',
    android: true,
    src: WATCH_ASSETS.watch14,
  },
  watch15: {
    name: 'watch15',
    altText: 'watch 15',
    ios: true,
    src: WATCH_ASSETS.watch15,
  },
  watch16: {
    name: 'watch16',
    altText: 'watch 16',
    ios: true,
    src: WATCH_ASSETS.watch16,
  },
  watch17: {
    name: 'watch17',
    altText: 'watch 17',
    ios: true,
    src: WATCH_ASSETS.watch17,
  },
  watch18: {
    name: 'watch18',
    altText: 'watch 18',
    ios: true,
    src: WATCH_ASSETS.watch18,
  },
  none: {
    name: 'none',
    altText: 'No Image',
    src: '',
  },
} as const;

export const WATCH_IMAGES_FORM_V2 = {
  watch5: {
    name: 'watch5',
    altText: 'watch 5',
    ios: true,
    src: WATCH_ASSETS.watch5,
  },
  watch6: {
    name: 'watch6',
    altText: 'watch 6',
    ios: true,
    src: WATCH_ASSETS.watch6,
  },
  watch7: {
    name: 'watch7',
    altText: 'watch 7',
    ios: true,
    src: WATCH_ASSETS.watch7,
  },
  watch4: {
    name: 'watch18',
    altText: 'watch 18',
    ios: true,
    src: WATCH_ASSETS.watch18,
  },
  watch8: {
    name: 'watch8',
    altText: 'watch 8',
    android: true,
    src: WATCH_ASSETS.watch8,
  },
  watch9: {
    name: 'watch9',
    altText: 'watch 9',
    android: true,
    src: WATCH_ASSETS.watch9,
  },
  watch10: {
    name: 'watch10',
    altText: 'watch 10',
    ios: true,
    familyPlanOnly: true,
    src: WATCH_ASSETS.watch10,
  },
  watch11: {
    name: 'watch11',
    altText: 'watch 11',
    ios: true,
    familyPlanOnly: true,
    src: WATCH_ASSETS.watch11,
  },
  watch12: {
    name: 'watch12',
    altText: 'watch 12',
    android: true,
    src: WATCH_ASSETS.watch12,
  },
  watch13: {
    name: 'watch13',
    altText: 'watch 13',
    android: true,
    familyPlanOnly: true,
    src: WATCH_ASSETS.watch13,
  },
  watch20: {
    name: 'watch16',
    altText: 'watch 16',
    ios: true,
    familyPlanOnly: true,
    src: WATCH_ASSETS.watch16,
  },
  watch16: {
    name: 'watch15',
    altText: 'watch 15',
    ios: true,
    familyPlanOnly: true,
    src: WATCH_ASSETS.watch15,
  },
  watch17: {
    name: 'watch10',
    altText: 'watch 10',
    ios: true,
    src: WATCH_ASSETS.watch10,
  },
  watch18: {
    name: 'watch11',
    altText: 'watch 11',
    ios: true,
    src: WATCH_ASSETS.watch11,
  },
  watch15: {
    name: 'watch15',
    altText: 'watch 15',
    ios: true,
    src: WATCH_ASSETS.watch15,
  },
  watch19: {
    name: 'watch16',
    altText: 'watch 16',
    ios: true,
    src: WATCH_ASSETS.watch16,
  },
  watch21: {
    name: 'watch17',
    altText: 'watch 17',
    android: true,
    familyPlanOnly: true,
    src: WATCH_ASSETS.watch17,
  },
  watch22: {
    name: 'watch17',
    altText: 'watch 17',
    android: true,
    src: WATCH_ASSETS.watch17,
  },
};
